import { KanbanContext } from "./kanban.context";
import type { KanbanBoardProps } from "./types-kanban";
import { useKanban } from "./use-kanban";
import { KanbanView } from "./view-kanban";

export function KanbanBoard({ children, ...options }: KanbanBoardProps) {
  const viewModel = useKanban(options);

  return (
    <KanbanContext.Provider value={viewModel.context}>
      <KanbanView
        device={viewModel.device}
        bleedClassName={viewModel.bleedClassName}
        scrollerRef={viewModel.scrollerRef}
        testId={viewModel.testId}
        scrollBarTestId={viewModel.scrollBarTestId}
        className={viewModel.className}
        style={viewModel.style}
        rest={viewModel.rest}
      >
        {children}
      </KanbanView>
    </KanbanContext.Provider>
  );
}
KanbanBoard.displayName = "Kanban.Board";
